'use client'

import { NavigationProps } from '@ccpgames/eve-web-core'
import { Navigation } from '@ccpgames/eve-web-core'
import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'
import LanguageSelector from '../language-selector/LanguageSelector'
import { SimpleHeader } from './SimpleHeader'

interface HeaderProps {
  items?: NavigationProps['items']
  locale: string
  authSlot?: ReactNode
  variant?: 'full' | 'simple'
}

export function Header({ items, locale, authSlot, variant = 'full' }: HeaderProps) {
  const pathname = usePathname()
  // Strip the leading locale segment for nav matching.
  // Handles both "/en" and "/en/..." forms, and normalizes locale root pages back to "/".
  const sanitizedPathname = pathname.replace(new RegExp(`^/${locale}(?=/|$)`), '') || '/'
  const safeItems = items ?? []

  if (variant === 'simple') return <SimpleHeader />

  return (
    <Navigation
      style={{ zIndex: '9999' }}
      items={safeItems}
      currentPath={sanitizedPathname}
      languageSelector={<LanguageSelector currentLocale={locale} />}
      /** Mobile Menu footer component */
      userComponent={authSlot}
      mobileMenuFooter={<LanguageSelector currentLocale={locale} flatList={true} />}
    />
  )
}
